import { GET_SINGLE_WIX, GET_WIX } from "../../actions/type";

// activity intial state
const initialWix = {
    allWix: null,
    wixForEdit: null,
    isLoading: true,
    isEditLoading: true,
};

export const reducer = (state = initialWix, action) => {
    switch (action.type) {
        case GET_WIX: {
            const allWix = action.payload;
            return {
                ...state,
                allWix: allWix,
                isLoading: false,
            };
        }
        case GET_SINGLE_WIX: {
            const wixForEdit = action.payload;
            return {
                ...state,
                wixForEdit,
                isEditLoading: false,
            };
        }
        default:
            return state;
    }
};